import React from 'react';
import { LoginPage } from './login/LoginPage'
import { Navigation } from './navigation/Navigation'
import { useSelector } from 'react-redux'
import { RootState } from './reducers/combineReducer'
import { Loading } from './components/utils/Loading';
import { LoginState } from './types/types';

export const App: React.FC = () => {

  const { loggedIn, initLoading }  = useSelector((state: RootState) => state['loginState']) as unknown as LoginState
  const loadingStyle = 'flex justify-center align-center items-center h-screen w-screen'

  
  return (
      initLoading ?
      <Loading styles={loadingStyle}/>
      : loggedIn ? 
      <Navigation /> 
      : <LoginPage />
  );
}

export default App;
